module.exports = __webpack_public_path__ + "static/media/aw.29aeb3f9.svg";